import type { FaireProductEntity } from "../../entity_types/product";

export const p_m6kt8g8ccc: FaireProductEntity = {
  token: "p_m6kt8g8ccc",
  type: "product",
  name: "Soul Eater, Vol. 12",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/57d80c1026a7ac1cb1fd7e93ab3159f1c5b05d3ee0621c4237776744b6b8c791.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "The DWMA student body is still reeling after the news that one of their own is a witch. But as one young witch flees Death City, another has come back to DWMA hoping to strike a deal with Shinigami-sama. Medusa has already proven herself a traitor to the school, but the information she offers is critical to DWMA's efforts to take down Arachnophobia and curb the spread of madness. Can Medusa be trusted to lead a team of students into the heart of enemy territory?!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:30.622Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
